document.addEventListener('DOMContentLoaded', function () {

    const buttons = document.querySelectorAll('.sub-question-button');

    for (const button of buttons) {
        button.addEventListener('click', () => {
            const arrow = button.querySelector('.sub-question-arrow');
            arrow.classList.toggle('rotate');
            arrow.classList.toggle('no-rotate');
        })
    }
});



